export interface IBaseArticle {
  id: number;
  isBio?: boolean;
  isOwnProduction?: boolean;
  name: string;
  orderNumber?: string;
}
